import React from 'react';
import { Link } from 'react-router-dom';

import { userService } from '../../services';

class HomePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            user: {},
            users: []
        };
    }

    componentDidMount() {
        const data = JSON.parse(localStorage.getItem('data'))
        this.setState({
            user: data.user,
            users: { loading: true }
        });
        //userService.getAll().then(users => this.setState({ users }));


    }

    render() {
        const { user, users } = this.state;
        return (
            <div className="col-md-12 ">
                <h1>Hi {user.prenoms + " "+ user.nom}!</h1>
                <p>You're logged in with React & Basic HTTP Authentication!!</p>
                <h3>Users from secure api end point:</h3>
                {users.loading && <em>Loading users...</em>}
                {users.length &&
                <ul>
                    {users.map((user, index) =>
                        <li key={user.id}>
                            {user.firstName + ' ' + user.lastName}
                        </li>
                    )}
                </ul>
                }
                <p>
                    <Link to="/login">Logout</Link>
                </p>
            </div>
        );
    }
}

export { HomePage };